/**
 * A utility function to determine whether a React class is equal to a react element's type.
 * @param {Function} classType - the React class to compare
 * @param {React.element} reactElement - the react element to compare (normally a child of this.props.children)
 * @return {Boolean} - true if the class and the reactElement.type match, false if not
 */
const isComponentOfType = (classType, reactElement) =>
  reactElement && reactElement.type === classType;

export default isComponentOfType;
export { isComponentOfType };
